export const ghlSwagRoutes = {
    default:'ghl_swag'
  }
  